import React from 'react';
import ReactDOM from 'react-dom';
import { Portfolio } from './Portfolio';


ReactDOM.render(
  <React.StrictMode>
    <Portfolio />
  </React.StrictMode>,
  document.getElementById('root')
);
